export function notification(notifyType, message, description) {
    function showNotification() {
        setTimeout(function () {
            $('.notification').slideDown('slow');
        }, 1000);
    }
    function hideNotification() {
        setTimeout(function () {
            $('.notification').slideUp('slow');
        }, 5000);
        setTimeout(function () {
            $('.notification').remove();
        }, 6000);
    }

    if(!description) {
        description = `Thank you for using ` + $('#app').data('name');
    }

    $('body').prepend(`
        <div class="notification ${notifyType}">
            <div class="notification-header">
                <h5 class="notification-title">${message}</h5>
            </div>
            <div class="delimiter"></div>
            <div class="notification-body">
                <p class="notification-text">${description}</p>
            </div>
        </div>
    `);

    showNotification()
    hideNotification()
}
